import { TPS_CAMERA_CONFIG, type CameraGroundBasis } from "./camera.js";

export interface TpsMovementIntent {
  x: number;
  z: number;
  heading: number | undefined;
}

/** Aim owns the horizontal basis. Locomotion never rotates or commits the camera. */
export class TpsMovementController {
  private readonly intent: TpsMovementIntent = { x: 0, z: 0, heading: undefined };
  reset(): void { this.intent.x = 0; this.intent.z = 0; this.intent.heading = undefined; }

  resolve(axisX: number, axisY: number, cameraBasis: CameraGroundBasis, _lookRevision = 0): TpsMovementIntent {
    const magnitude = Math.hypot(axisX, axisY);
    if (!Number.isFinite(magnitude) || magnitude < TPS_CAMERA_CONFIG.movementDeadZone) {
      this.reset();
      return this.intent;
    }
    const divisor = Math.max(1, magnitude);
    this.intent.x = (cameraBasis.forwardX * axisY + cameraBasis.rightX * axisX) / divisor;
    this.intent.z = (cameraBasis.forwardZ * axisY + cameraBasis.rightZ * axisX) / divisor;
    this.intent.heading = Math.atan2(this.intent.x, this.intent.z);
    return this.intent;
  }
}
